// import * as types from './actionsTypes'

export default {
    updateSettingInfo ({commit}, payload) {
        commit('putSettingInfo', payload)
    },
    renewGpsStatus ({ commit, state, getters},todo) {
        if (getters.gpsStatusDiffTime > 2000) {
            navigator.geolocation.getCurrentPosition(todo.onSuccess, todo.onError, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0,
            });
        }else{
            todo.tooEarly();
        }
    },
}